import React from 'react';
import {Grid} from '@mui/material';
import CostPoolBarChart from './CostPoolBarChart';
import ApplicationsTable from './ApplicationTable';

interface ApplicationData {
  name: string;
  users: number;
  importance: number;
  features: number;
  usability: number;
  dataQuality: number;
}
const flexContainerStyle: React.CSSProperties = {
  margin: 'auto',
  width: '98%',
  boxSizing: 'border-box',
  display: 'grid',
  gridTemplateColumns: '1fr ', // Equal width columns
  gridTemplateRows: '1fr 1fr', // Equal height rows
  gap: '10px',
  padding: '10px'
};

const flexItemStyle: React.CSSProperties = {
  textAlign: 'center',
  fontSize: '30px',
  display: 'grid'
};

const applicationsData: ApplicationData[] = [
  {
    name: 'Clinical Application',
    users: 587,
    importance: 94,
    features: 85,
    usability: 95,
    dataQuality: 89
  },
  {
    name: 'Microsoft Outlook Email',
    users: 434,
    importance: 97,
    features: 85,
    usability: 95,
    dataQuality: 95
  },
  {
    name: 'Workday',
    users: 434,
    importance: 87,
    features: 70,
    usability: 73,
    dataQuality: 77
  },
  {
    name: 'IT Ticketing System',
    users: 434,
    importance: 75,
    features: 75,
    usability: 73,
    dataQuality: 73
  },
  {
    name: 'SAP Crystal Reports',
    users: 423,
    importance: 52,
    features: 61,
    usability: 61,
    dataQuality: 74
  }
];
const applicationsData2: ApplicationData[] = [
  {
    name: 'Microsoft Skype',
    users: 434,
    importance: 21,
    features: 40,
    usability: 38,
    dataQuality: 47
  },
  {
    name: 'Decision Center',
    users: 27,
    importance: 22,
    features: 58,
    usability: 57,
    dataQuality: 67
  },
  {
    name: 'SAP Crystal Reports',
    users: 423,
    importance: 57,
    features: 61,
    usability: 61,
    dataQuality: 74
  },
  {
    name: 'Microsoft SSRS',
    users: 423,
    importance: 47,
    features: 60,
    usability: 60,
    dataQuality: 68
  },
  {
    name: 'Microsoft Dynamics',
    users: 87,
    importance: 21,
    features: 18,
    usability: 65,
    dataQuality: 45
  }
];
const applicationsData3: ApplicationData[] = [
  {
    name: 'Journals Management System',
    users: 87,
    importance: 55,
    features: 66,
    usability: 50,
    dataQuality: 52
  },
  {
    name: 'Clinical Application 2',
    users: 47,
    importance: 57,
    features: 61,
    usability: 51,
    dataQuality: 59
  },
  {
    name: 'Clinical Application 3',
    users: 17,
    importance: 22,
    features: 68,
    usability: 47,
    dataQuality: 47
  },
  {
    name: 'AIM Application',
    users: 37,
    importance: 71,
    features: 65,
    usability: 66,
    dataQuality: 69
  },
  {
    name: 'HomeCare App',
    users: 89,
    importance: 21,
    features: 54,
    usability: 36,
    dataQuality: 27
  }
];

const AnalysisComponent: React.FC = () => {
  return (
    <div>
      <div style={flexContainerStyle}>
        <div style={flexItemStyle}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <CostPoolBarChart />
            </Grid>
            <Grid item xs={6}>
              <ApplicationsTable
                data={applicationsData}
                names="Top 5 Applications"
              />
            </Grid>
          </Grid>
        </div>

        <div style={flexItemStyle}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <ApplicationsTable
                data={applicationsData2}
                names="Top Underperforming Apps"
              />
            </Grid>
            <Grid item xs={6}>
              <ApplicationsTable
                data={applicationsData3}
                names="Lowest Data Quality Applications"
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default AnalysisComponent;
